// src/pages/admin/DeliverySettings.js

import React, { useState, useEffect } from "react";
import { adminAPI } from "../../services/api";
import toast from "react-hot-toast";

const DeliverySettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await adminAPI.getDeliverySettings();
      setSettings(response.data.settings);
    } catch (error) {
      toast.error("Failed to load delivery settings");
    } finally {
      setLoading(false);
    }
  };

  const handleTogglePanIndia = async () => {
    if (!settings) return;

    const newValue = !settings.panIndiaEnabled;

    const confirmMessage = newValue
      ? "Enable Pan-India delivery? Customers will be able to order from all Indian states."
      : "Disable Pan-India delivery? Only Kerala orders will be accepted.";

    if (!window.confirm(confirmMessage)) return;

    try {
      setSaving(true);
      const response = await adminAPI.updateDeliverySettings({
        panIndiaEnabled: newValue,
      });

      setSettings(response.data.settings);
      toast.success(
        newValue
          ? "✅ Pan-India delivery enabled!"
          : "✅ Kerala-only delivery mode activated"
      );
    } catch (error) {
      toast.error("Failed to update settings");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="delivery-settings">
      <h2>Delivery Settings</h2>

      <div className="setting-card">
        <div className="setting-header">
          <h3>🚚 Delivery Coverage</h3>
          <div
            className={`status-badge ${
              settings.panIndiaEnabled ? "pan-india" : "kerala-only"
            }`}
          >
            {settings.panIndiaEnabled ? "Pan-India Enabled" : "Kerala Only"}
          </div>
        </div>

        <div className="setting-body">
          <p className="setting-description">
            {settings.panIndiaEnabled
              ? "Customers can order from all Indian states with varying delivery charges."
              : "Customers can only order from Kerala with FREE delivery."}
          </p>

          <button
            onClick={handleTogglePanIndia}
            disabled={saving}
            className={`toggle-btn ${
              settings.panIndiaEnabled ? "disable" : "enable"
            }`}
          >
            {saving
              ? "Updating..."
              : settings.panIndiaEnabled
              ? "🔒 Switch to Kerala-Only"
              : "🌍 Enable Pan-India Delivery"}
          </button>

          <div className="delivery-info">
            <h4>Current Delivery Rates:</h4>
            <ul>
              <li>
                <strong>Kerala:</strong> FREE
                {settings.panIndiaEnabled && " (orders under ₹2000)"}
              </li>
              {settings.panIndiaEnabled && (
                <>
                  <li>
                    <strong>Nearby States:</strong> ₹
                    {settings.panIndiaDelivery.nearbyCharge}
                    <small>
                      {" "}
                      ({settings.panIndiaDelivery.nearbyStates.join(", ")})
                    </small>
                  </li>
                  <li>
                    <strong>Other States:</strong> ₹
                    {settings.panIndiaDelivery.farCharge}
                  </li>
                  <li>
                    <strong>
                      Orders over ₹{settings.freeShippingThreshold}:
                    </strong>{" "}
                    ₹{settings.panIndiaDelivery.farCharge} (all states)
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliverySettings;
